import { User } from '@auth0/auth0-spa-js'
import { AUDIENCE_URL } from '../config'

export const isRoleCapoTecnico = (user?: User): boolean => {
  const role = user && user[`${AUDIENCE_URL}/roles`].find((role: string) => role === 'CAPO-TECNICO')

  return role === 'CAPO-TECNICO' ? true : false
}
